import * as yup from "yup";

export const addPaymentTransactionThruEmailSchema = yup.object().shape({
  amount: yup
    .number("Please input amount")
    .min(0, "The minimum amount is 0")
    .typeError("Amount is required")
    .required("Amount is required"),
  caseProgressId: yup.string().required("Case Progress Id is required"),
});
